import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getInfoWarranty,
  selectInfoWarranty,
  warrantyActions,
} from "../../redux/reducers/slice/warranty";
import "./infoWarrantyStyle.scss";
import ScanQRWarantyModal from "./scanQR";

const InformationWarranty = (props: any) => {
  const [visible, setVisible] = useState(false);
  const [typeQR, setTypeQR] = useState("SCAN");
  const infoWarranty = useSelector(selectInfoWarranty);
  const dispatch = useDispatch();

  useEffect(() => {
    if (infoWarranty) {
      if (!infoWarranty.is_activated) {
        dispatch(getInfoWarranty(infoWarranty?.uid || ""));
        props.setStep(2);
      } else {
        props.setStep(0);
      }
    }
  }, [infoWarranty]);

  return (
    <>
      <p className="warranty__title main-title">Thông tin bảo hành điện tử</p>

      <p className="warranty__guide main-content">
        Để kiểm tra hoặc đăng kí thông tin bảo hành điện tử của các sản phẩm
        Kymdan, Quí khách vui lòng nhập thông tin mã số bảo hành của sản phẩm đã
        mua theo 1 trong 2 phương thức bên dưới:
      </p>

      <div className="warranty__method-input">
        {/* <div className="warranty__method-input__container">
          <div className="icon main-content">
            <i className="far fa-circle"></i>
          </div>
          <div className="warranty-number">
            <p className="warranty-number__title sub-title">Nhập số bảo hành</p>
            <p className="warranty-number__guide main-content">
              (Số bảo hành ghi trên phiếu bảo hành kèm theo sản phẩm)
            </p>
            <div className="warranty-number__input">
              <input
                type="text"
                placeholder="1234567890ABC"
                className="input sub-title"
              />
              <div
                className="btn"
                // onClick={handleContinue}
              >
                <p className="btn__text sub-title">Tiếp tục</p>
              </div>
            </div>
          </div>
        </div> */}

        <div className="warranty__method-input__container">
          {/* <div className="icon main-content">
            <i className="far fa-circle"></i>
          </div> */}
          <div className="warranty-scan">
            <div className="warranty-scan__container">
              <p className="warranty-scan__title sub-title">
                Quét mã QR từ camera
              </p>
              <div
                className="btn btn--large"
                onClick={() => {
                  setTypeQR("SCAN");
                  dispatch(warrantyActions.resetError());
                  setVisible(true);
                }}>
                <p className="btn__text sub-title">Quét ngay</p>
              </div>
            </div>
            <p className="warranty-scan__guide main-content">
              (Mã QR được in trên phiếu bảo hành hoặc trên nhãn thông tin sản
              phẩm)
            </p>
          </div>
        </div>

        <div className="warranty__method-input__container">
          <div className="warranty-scan">
            <div className="warranty-scan__container">
              <p className="warranty-scan__title sub-title">Tải mã QR từ máy</p>
              <div
                className="btn btn--large"
                onClick={() => {
                  setTypeQR("UPLOAD");
                  dispatch(warrantyActions.resetError());
                  setVisible(true);
                }}>
                <p className="btn__text sub-title">Tải ngay</p>
              </div>
            </div>
            <p className="warranty-scan__guide main-content">
              (Mã QR được in trên phiếu bảo hành hoặc trên nhãn thông tin sản
              phẩm)
            </p>
          </div>
        </div>
      </div>

      {visible && (
        <ScanQRWarantyModal
          visible={visible}
          typeQR={typeQR}
          setVisible={setVisible}
          setTypeQR={setTypeQR}
        />
      )}
    </>
  );
};

export default InformationWarranty;
